import { FC, ReactElement } from 'react';
import { navigate } from 'gatsby';

export interface RedirectRouterProps {
  component: ReactElement;
  location: { state: any };
  to: string;
}

export const RedirectRouter: FC<RedirectRouterProps> = ({ component, location, to }) => {
  const { state } = location;

  if (!state && typeof window !== `undefined`) {
    navigate(to);
    return null;
  }

  return component;
};
